import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed bottom-0 h-full w-full animate__animated animate__fadeInUp animate__faster left-0" }
const _hoisted_2 = { class: "flex flex-col w-full h-full items-end" }
const _hoisted_3 = { class: "grow w-full overflow-hidden justify-end border dark:border-none shadow-2xl bg-neutral-200 dark:bg-neutral-800 border-b border-neutral-300 dark:border-neutral-700" }
const _hoisted_4 = { class: "flex flex-col h-full rounded-r-md" }
const _hoisted_5 = {
  key: 0,
  class: "flex-none"
}
const _hoisted_6 = { class: "flex space-x-1 items-center pt-0.5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs dark:text-neutral-300" }, " Conectando ... ", -1)
const _hoisted_8 = { class: "grow overflow-auto" }

import { ref, computed, watch } from 'vue'
    import useToggleTheme from '@/hooks/useToggleTheme'
    import Icon from '@/components/Icon/IndexIcon.vue'
    import HomeChart from '@/components/WebChatInternal/HomeChart.vue'
    import useWebSocketChat from '@/hooks/useWebSocketChat'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BoxInternChat',
  props: {
        bgColor: {
            type: String,
            default: '#000'
        },
        right: {
            type: String,
            default: '20'
        }
    },
  setup(__props) {

    

    const box = ref<HTMLElement | null>(null)

    const { status } = useWebSocketChat()
    const { themeDark } = useToggleTheme()

    const IconColor = computed(() => (themeDark() ? 'white' : 'black'))

    watch(() => status.value, () => {
        if (status.value !== 'OPEN') {
            console.log('BLOQUEAR TELA')
        }
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(status) != 'OPEN')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "flex bg-neutral-200 dark:bg-neutral-800 border-b px-2 pt-3 pb-3 border-neutral-300 dark:border-neutral-700 justify-between",
                  ref_key: "box",
                  ref: box
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(Icon, {
                      size: "14",
                      name: "LoadingCircle",
                      color: _unref(IconColor)
                    }, null, 8, ["color"]),
                    _hoisted_7
                  ])
                ], 512)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(HomeChart, { mobile: true })
          ])
        ])
      ])
    ])
  ]))
}
}

})